<template>
  <div>
    <div class="breadcrumb-area pos-relative">
      <h1>Chi tiết lịch làm việc</h1>
      <div class="float-right">
        <button
          class="btn btn-outline-secondary ml-2"
          v-if="
            dataPermission.includes('CNPS_WKCLDR_UPSERT_WKCLDR') &&
            dataDetail.statusWkcldr &&
            dataDetail.statusWkcldr === 'NOT_PROCESS'
          "
          @click="editCalendar()"
        >
          <i class="bx bx-edit-alt"></i> Sửa
        </button>
        <button
          class="btn btn-outline-secondary ml-2"
          v-if="
            dataPermission.includes('CNPS_WKCLDR_UPSERT_WKCLDR') &&
            dataDetail.statusWkcldr &&
            dataDetail.statusWkcldr === 'NOT_PROCESS'
          "
          @click="updateResult()"
        >
          <i class="bx bx-calendar-edit"></i> Cập nhật KQ
        </button>
        <button @click="backtoList" class="btn btn-outline-secondary ml-2">Quay lại</button>
      </div>
    </div>
    <div v-if="loading" class="card p-0 b-t-1-869fb229 text-center">
      <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
    </div>
    <div v-else class="card p-0 b-t-1-869fb229">
      <div class="card-body p-10 b-t-1-869fb229">
        <span v-if="dataDetail.saleInfo.avatar" class="de-img"
          ><img :src="dataDetail.saleInfo.avatar" alt="img"
        /></span>
        <span v-else class="de-img"><img :src="userDefaultImage" alt="img" /></span>
        <div class="de-info">
          <h3 class="de-name">{{ dataDetail.saleInfo.name }}</h3>
          <span class="s">Mã: {{ dataDetail.saleInfo.companyCode }}</span>
        </div>
        <div class="clearfix"></div>

        <div class="tab-content">
          <div class="tab-pane fade show active">
            <div class="form-row mb-2">
              <div class="col-md-6 my-2">
                <!-- Tab panes -->

                <div class="form-detail">
                  <div class="mb-4">
                    <h1 class="pb-1"><b>Thông tin công việc</b></h1>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Mục đích/Hình thức</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataDetail.purposes }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">TG dự kiến</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.startTime | formatDate('HH:mm DD/MM/YYYY') }} -
                          {{ dataDetail.endTime | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Trạng thái</label>
                      <div class="col-sm-8 p-t-10">
                        <span v-if="dataDetail.isDeleted" class="badge badge-danger">Hủy</span>
                        <span v-else-if="dataDetail.outcome > 0" class="badge badge-primary"
                          >Đã xử lý</span
                        >
                        <span v-else class="badge badge-warning">Chưa xử lý</span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Độ ưu tiên</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.isPeriod | transformData(dataPeriod) }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Điểm hẹn</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataDetail.address }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Nhân viên xử lý</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.saleInfo.name }} - {{ dataDetail.saleInfo.userName }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row mb-2"
                      v-if="dataDetail.saleInfo.name !== dataDetail.createdByInfo.name"
                    >
                      <label class="col-sm-4 col-form-label f12">Người tạo</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.createdByInfo.name }} -
                          {{ dataDetail.createdByInfo.userName }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">TG tạo</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">TG cập nhật</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Kết quả</label>
                      <div class="col-sm-8">
                        <!-- <p  class="form-control-plaintext f12">{{ dataDetail.statusCat | transfromStatusCat(purposesStatus) }}</p> -->
                        <p class="form-control-plaintext f12">{{ dataDetail.resultDisplay }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">TG hoàn thành</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.timeFinish | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">TG thực hiện</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataDetail.startTime | formatDate('HH:mm DD/MM/YYYY') }} -
                          {{ dataDetail.endTime | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Ghi chú</label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataDetail.depcription }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 my-2">
                <!-- Tab panes -->
                <div class="form-detail">
                  <div class="mb-4">
                    <h1 class="pb-1"><b>Thông tin Khách hàng</b></h1>

                    <!-- <div class="form-group row">
                      <label class="col-sm-4 col-form-label f12">Logo</label>
                      <div class="col-sm-8">
                        <div v-if="dataDetail.merchantInforRes">
                          <span v-for="(image, index) in dataDetail.merchantInforRes.avatarUrl" :key="index"><img :src="image" :alt="`merchant-logo-${index}`"></span>
                        </div>
                      </div>
                    </div> -->

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Tên khách hàng</label>
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-if="dataDetail.merchantInforRes || dataDetail.leadInfoRes"
                        >
                          {{
                            dataDetail.merchantInforRes
                              ? dataDetail.merchantInforRes.customerName
                              : dataDetail.leadInfoRes.customerName
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Số điện thoại</label>
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-if="dataDetail.merchantInforRes || dataDetail.leadInfoRes"
                        >
                          {{
                            dataDetail.merchantInforRes
                              ? dataDetail.merchantInforRes.mobile
                              : dataDetail.leadInfoRes.mobile
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Email</label>
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-if="dataDetail.merchantInforRes || dataDetail.leadInfoRes"
                        >
                          {{
                            dataDetail.merchantInforRes
                              ? dataDetail.merchantInforRes.email
                              : dataDetail.leadInfoRes.email
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2">
                      <label class="col-sm-4 col-form-label f12">Địa chỉ</label>
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-if="dataDetail.merchantInforRes || dataDetail.leadInfoRes"
                        >
                          {{
                            dataDetail.merchantInforRes
                              ? dataDetail.merchantInforRes.address
                              : dataDetail.leadInfoRes.address
                          }}
                        </p>
                      </div>
                    </div>

                    <div v-if="dataDetail.urlImage" class="form-group form-row mb-2 img-list">
                      <label class="col-sm-4 col-form-label f12">Ảnh</label>
                      <div class="mt-2">
                        <ul class="list-img" v-viewer>
                          <li v-for="(image, index) in dataDetail.urlImage" :key="index">
                            <a href="javascript:void(0)">
                              <img :src="image" alt="" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="dataDetail.checkinImage" class="form-group form-row mb-2 img-list">
                      <label class="col-sm-4 col-form-label f12">Ảnh checkin </label>
                      <div class="mt-2">
                        <ul class="list-img" v-viewer>
                          <li v-for="(image, index) in dataDetail.checkinImage" :key="index">
                            <a href="javascript:void(0)">
                              <img :src="image" alt="" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userDefaultImage from '@/assets/img/user.svg'
  import { CommonService } from '@/services/common.service'
  import { CalendarService } from '@/services/calendar.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'

  export default {
    components: {},
    data() {
      return {
        loading: true,
        userDefaultImage: userDefaultImage,
        dataDetail: {},
        dataConfigPurposes: [],
        purposesStatus: [],
        dataPeriod: Config.dataPeriod,
      }
    },

    async created() {
      const id = this.$route.query.id
      this.fetchData(id)
    },

    methods: {
      backtoList() {
        this.$router.push('/calendar')
      },
      async fetchData(id) {
        try {
          this.loading = true
          const { data } = await CalendarService.getById({ id })
          this.dataDetail = data
          const config = await CommonService.getConfigSystem()
          if (config.success) {
            const dataPurposes = []
            config.data.purposes.map(e => {
              dataPurposes.push({
                id: e.code,
                text: e.name,
              })
              this.purposesStatus = [...this.purposesStatus, ...e.purposesStatus]
            })
            this.dataConfigPurposes = dataPurposes
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      editCalendar() {
        this.$router.push(`/calendar-edit/${this.$route.query.id}`)
      },

      updateResult() {
        this.$router.push(`/update-work/${this.$route.query.id}`)
      },
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
  }
</script>
<style scoped>
  .pos-relative {
    width: 100%;
  }
</style>
